<template>
  <div id="katalog">
    <div class="temp_card">
      <v-card elevation="10" class="rounded-xl">
        <div class="menu-katalog" style="width: 100%">
          <div class="px-10 py-5 d-flex justify-start align-center">
            <div>
              <v-avatar color="" size="50">
                <v-img
                  contain
                  lazy-src="../../assets/img/logo-teman-bakat.png"
                  max-height="200"
                  max-width="200"
                  src="../../assets/img/logo-teman-bakat.png"
                ></v-img>
              </v-avatar>
            </div>
            <div class="item-menu-katalog ml-5">
              <a
                href="https://temanbakat.id"
                style="color: black; text-decoration: none"
                >Beranda</a
              >
            </div>
          </div>
        </div>
        <v-row>
          <v-col cols="12" md="6">
            <div class="py-12 px-12">
              <div class="d-flex justify-center">
                <img
                  src="../../assets/img/logo-teman-bakat.png"
                  @click="goHome"
                  height="100px"
                  alt="logo-teman-bakat"
                  class="mb-2 logo_tb"
                />
              </div>
              <h1>
                Panduan kiat sukses <br />
                seleksi kerja
              </h1>
              <div class="wrap-download">
                <v-btn
                  @click="
                    download(
                      `https://nos.wjv-1.neo.id/temanbakat/penjurusan/katalog/sukses_lolos_seleksi_kerja.pdf`,
                    )
                  "
                  color="#450073"
                  dark
                  elevation="2"
                  class="text-capitalize rounded-lg"
                  height="50"
                  >Unduh PDF</v-btn
                >
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="d-flex justify-end">
              <img
                src="../../assets/img/seleksi_kerja/splash_screen.png"
                height="300px"
                alt="ilustration-teman-bakat"
              />
            </div>
          </v-col>
        </v-row>
        <!-- <div v-if="!isDownload" class="d-flex justify-start align-center">
          <div v-if="!isDownload" class="py-12 px-12 desc" style="width: 80%">
            <h1>
              Panduan kiat sukses <br />
              seleksi kerja
            </h1>
            <div class="wrap-download">
              <v-btn
                @click="
                  download(
                    `https://nos.wjv-1.neo.id/temanbakat/penjurusan/katalog/sukses_lolos_seleksi_kerja.pdf`,
                  )
                "
                color="#450073"
                dark
                elevation="2"
                class="text-capitalize rounded-lg"
                height="50"
                >Unduh PDF</v-btn
              >
            </div>
          </div>
        </div> -->
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeleft: 0,
      isDownload: false,
    };
  },
  name: "penjurusan-katalog",
  methods: {
    goHome() {
      window.location.href = "https://temanbakat.id";
    },
    countdown() {
      let vm = this;
      let timeleft = 6;
      let timer = setInterval(function () {
        timeleft--;
        vm.timeleft = timeleft;
        if (timeleft === 0) {
          vm.$router.push("/penjurusan");
          clearInterval(timer);
        }
      }, 1000);
    },

    download(uri) {
      let a = document.createElement("a");
      a.target = "_blank";
      a.href = uri;
      a.click();
      // this.isDownload = true;
      // this.countdown();
    },

    toPenjurusan() {
      let vm = this;
      vm.$router.push("/penjurusan");
    },
  },
};
</script>

<style>
#katalog {
  background-color: #edeaf4;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.menu-katalog {
  background-image: url("../../assets/img/penjurusan/asset1a.png");
}
.item-menu-katalog {
  cursor: pointer;
}
/* .katalog-card {
  background-image: url("../../assets/img/penjurusan/asset-solo.png");
  background-position: bottom right;
  background-size: 300;
} */
.silakan {
  font-weight: 800;
  font-size: 72px;
  color: #450073;
}
.penjurusan-tb {
  font-size: 36px;
  font-weight: bold;
  color: #450073;
}
.katalog {
  font-size: 36px;
}
.dibawah {
  font-size: 36px;
}

.temp_card {
  width: 70%;
}
.logo_tb {
  display: none;
}
@media (max-width: 576px) {
  #katalog {
    height: 100%;
    padding: 20px 0px 20px 0px;
  }

  .katalog-card {
    height: max-content;
  }
  .logo_tb {
    display: block;
  }
  .temp_card {
    width: 95%;
  }
  .desc {
    width: 100% !important;
    padding: 0px !important;
  }

  .menu-katalog {
    display: none !important;
  }

  .terimakasih {
    font-size: 25px !important;
    line-height: 85% !important;
  }

  .mengunduh {
    font-size: 15px !important;
    line-height: 95% !important;
  }

  .penjurusan {
    font-size: 15px !important;
    line-height: 95% !important;
    margin-top: -5%;
  }

  .dialihkan {
    font-size: 15px !important;
  }

  .silakan {
    font-weight: 800;
    font-size: 42px;
    color: #450073;
  }
  .penjurusan-tb {
    font-size: 16px;
    font-weight: bold;
    color: #450073;
  }
  .katalog {
    font-size: 16px;
  }
  .dibawah {
    font-size: 16px;
  }
}
</style>
